export default "__VITE_ASSET__B84Fc4nR__"